import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';
import rootReducer from './modules';
let middlewares;


if (process.env.NODE_ENV === 'production')
	middlewares = applyMiddleware(thunk);
else
	// middlewares = applyMiddleware(thunk);
	middlewares = applyMiddleware(thunk, createLogger());

function create(initialState) {
	const store = createStore(
		rootReducer,
		initialState,
		compose(
			middlewares,
			window.devToolsExtension ? window.devToolsExtension() : f => f
		)
	);


	if (module.hot) {
		module.hot.accept('./modules/index', () => {
			store.replaceReducer(require('./modules/index').default); // eslint-disable-line
		});
	}

	return store;
}

export default create;